<template>
  <div class="support-footer">
    <div class="support">נתקלת בבעיה בכניסה? יש לך שאלה?</div>
    <a class="support-link" href="mailto:support@riseup.co.il?subject=יש לי שאלה" target="_blank">support@riseup.co.il</a>
  </div>
</template>

<script>
export default {
  name: 'LoginSupportFooter',
};
</script>

<style lang="scss" scoped>
  @import '../scss/riseup-colors';

  .support-footer {
    margin-top: 40px;
    text-align: center;
    font-size: 16px;
    line-height: 22px;
    color: $riseup_black;

    .support-link {
      margin-top: 8px;
      color: $riseup_blue;
      cursor: pointer;
    }
  }
</style>
